// src/pages/Careers.js
import React from 'react';

function Careers() {
  return <div><h2>Careers</h2><p>This is the Careers page.</p></div>;
}

export default Careers;
